export default __webpack_public_path__ + "static/media/bg.5d261fd9.png";